import * as React from 'react';
/**
 * Значение, отстающее от входного на `delayMs` после последнего изменения.
 *
 * Для поисковых полей, где каждое нажатие не должно уезжать на сервер:
 * поле держит «сырое» значение, а запрос строится по отложенному. Новое
 * изменение до истечения паузы сбрасывает таймер — в сеть уходит только
 * то, на чём оператор остановился.
 */
export function useDebouncedValue(value, delayMs) {
    const [debounced, setDebounced] = React.useState(value);
    React.useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(t);
    }, [value, delayMs]);
    return debounced;
}
//# sourceMappingURL=use-debounced-value.js.map